import { components } from "react-select";
import styled from "styled-components";

// Custom MenuList to prepend CreateOption
const CustomMenuList = (props) => {
  const {
    children,
    selectProps: { onCreateNew, inputValue, createNewLabel },
  } = props;

  const showCreateNew = !inputValue; // show only when input is empty

  return (
    <components.MenuList {...props}>
      {showCreateNew && (
        <MenuListContainer onClick={() => onCreateNew()}>
          {createNewLabel}
        </MenuListContainer>
      )}
      {children}
    </components.MenuList>
  );
};

export default CustomMenuList;

//styles
const MenuListContainer = styled.div`
  padding: 10px;
  cursor: pointer;
  font-weight: 500;
  background: #eff6ff;
  border-bottom: 1px solid #e0e0e0;
  color: #1976d2;
  &:hover {
    background: #e3f2fd;
  }
`;
